import { render, staticRenderFns } from "./Editions.vue?vue&type=template&id=1b8cd3e8&lang=pug&"
import script from "./Editions.vue?vue&type=script&lang=js&"
export * from "./Editions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports